<template>
  <aside :data-open="statusFilters">
    <div>
      <status :games="games" @change="changeStatus"/>
      <show-hide :games="games" @change="changeFilters"/>
      <dates @change="changeDates" :dateStart="dateStart" :dateEnd="dateEnd"/>
      <competition
        @changeSeason="changeSeason"
        @changeArea="changeArea"
        @changeCompetition="changeCompetition"
      />
      <event
        @changeSport="changeSport"
        @changeDiscipline="changeDiscipline"
        @changeEvent="changeEvent"
        @changeClassification="changeClassification"
        @changeGender="changeGender"
        @changeEventUnits="changeEventUnits"
      />
      <day
        @changeRoundType="changeRoundType"
        @changeGroupType="changeGroupType"
        @changeDay="changeDay"
      />
    </div>
  </aside>
</template>

<script>
import Competition from '@/components/sport/games/filters/Competition'
import Dates from '@/components/sport/games/filters/Date'
import Day from '@/components/sport/games/filters/Day'
import Event from '@/components/sport/games/filters/Event'
import ShowHide from '@/components/sport/games/filters/ShowHide'
import Status from '@/components/sport/games/filters/Status'
export default {
  name: 'SportGamesFilters',
  components: { Competition, Dates, Day, Event, ShowHide, Status },
  props: {
    games: Array,
    statusFilters: Boolean
  },
  data () {
    return {
      seasonId: null,
      areaId: null,
      competitionsId: [],
      sportId: null,
      disciplineId: null,
      eventId: null,
      classificationId: null,
      genderId: null,
      eventUnitsId: [],
      roundsTypeId: [],
      groupsTypeId: [],
      dayId: null,
      dateStart: new Date(),
      dateEnd: new Date()
    }
  },
  methods: {
    changeSeason (event) {
      this.seasonId = event.target.value > 0 ? parseInt(event.target.value) : null
      // this.updateArea()
      this.updateCompetition()
      this.updateSport()
      this.updateDiscipline()
      this.updateEvent()
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeArea (event) {
      this.areaId = event.target.value > 0 ? parseInt(event.target.value) : null
      this.updateCompetition()
      this.updateSport()
      this.updateDiscipline()
      this.updateEvent()
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeCompetition (event) {
      this.competitionsId = []
      for (let i = 0; i < event.target.options.length; i++) {
        const option = event.target.options[i]
        if (option.selected) {
          this.competitionsId.push(option.value)
        }
      }
      this.updateSport()
      this.updateDiscipline()
      this.updateEvent()
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeSport (event) {
      this.sportId = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : null
      this.updateDiscipline()
      this.updateEvent()
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeDiscipline (event) {
      this.disciplineId = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : null
      this.updateEvent()
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeEvent (event) {
      this.eventId = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : null
      this.updateClassification()
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeClassification (event) {
      this.classificationId = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : null
      this.updateGender()
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeGender (genderId) {
      this.genderId = genderId
      this.updateEventUnit()
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeEventUnits (event) {
      this.eventUnitsId = []
      for (let i = 0; i < event.target.options.length; i++) {
        const option = event.target.options[i]
        if (option.selected) {
          this.eventUnitsId.push(option.value)
        }
      }
      this.updateRoundType()
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeRoundType (event) {
      this.roundsTypeId = []
      for (let i = 0; i < event.target.options.length; i++) {
        const option = event.target.options[i]
        if (option.selected) {
          this.roundsTypeId.push(option.value)
        }
      }
      this.updateGroupType()
      this.updateDay()
      this.updateGame()
    },
    changeGroupType (event) {
      this.groupsTypeId = []
      for (let i = 0; i < event.target.options.length; i++) {
        const option = event.target.options[i]
        if (option.selected) {
          this.groupsTypeId.push(option.value)
        }
      }
      this.updateDay()
      this.updateGame()
    },
    changeDay (dayId) {
      this.dayId = dayId
      this.updateGame()
    },
    changeDates (dates) {
      if (dates && dates.length === 2) {
        this.dateStart = dates[0]
        this.dateEnd = dates[1]
      } else {
        this.dateStart = null
        this.dateEnd = null
      }
      this.updateGame()
    },
    changeStatus (statuses) {
      this.$emit('changeStatus', statuses)
    },
    changeFilters (filters) {
      this.$emit('changeFilters', filters)
    },
    updateArea () {
      this.areaId = null
      this.$store.dispatch('Main/Area/set', { seasonId: this.seasonId })
    },
    updateCompetition () {
      this.cometitionsId = []
      const parameters = { seasonId: this.seasonId, areaId: this.areaId }
      this.$store.dispatch('Sport/Competition/set', parameters)
    },
    updateSport () {
      this.sportId = null
      const parameters = { seasonId: this.seasonId, competitionsId: this.competitionsId }
      this.$store.dispatch('Sport/Sport/set', parameters)
    },
    updateDiscipline () {
      this.disciplineId = null
      const parameters = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId
      }
      this.$store.dispatch('Sport/Discipline/set', parameters)
    },
    updateEvent () {
      this.eventId = null
      const parameters = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        disciplineId: this.disciplineId
      }
      this.$store.dispatch('Sport/Event/set', parameters)
    },
    updateClassification () {
      this.classificationId = null
      const parameters = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId
      }
      this.$store.dispatch('Sport/Classification/set', parameters)
    },
    updateGender () {
      this.genderId = null
      const parameters = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId
      }
      this.$store.dispatch('Sport/Gender/set', parameters)
    },
    updateEventUnit () {
      this.eventUnitsId = []
      const data = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId,
        genderId: this.genderId
      }
      this.$store.dispatch('Sport/EventUnit/set', data)
    },
    updateRoundType () {
      this.roundsTypeId = []
      const data = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId,
        genderId: this.genderId,
        eventUnitsId: this.eventUnitsId
      }
      this.$store.dispatch('Sport/RoundType/set', data)
    },
    updateGroupType () {
      this.groupsTypeId = []
      const data = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId,
        genderId: this.genderId,
        eventUnitsId: this.eventUnitsId,
        roundsTypeId: this.roundsTypeId
      }
      this.$store.dispatch('Sport/GroupType/set', data)
    },
    updateDay () {
      this.dayId = null
      const data = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId,
        genderId: this.genderId,
        eventUnitsId: this.eventUnitsId,
        roundsTypeId: this.roundsTypeId,
        groupsTypeId: this.groupsTypeId
      }
      this.$store.dispatch('Sport/Day/set', data)
    },
    updateGame () {
      const data = {
        seasonId: this.seasonId,
        competitionsId: this.competitionsId,
        sportId: this.sportId,
        categoryId: this.categoryId,
        disciplineId: this.disciplineId,
        eventId: this.eventId,
        classificationId: this.classificationId,
        genderId: this.genderId,
        eventUnitsId: this.eventUnitsId,
        roundsTypeId: this.roundsTypeId,
        groupsTypeId: this.groupsTypeId,
        dayId: this.dayId,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        dateTest: this.dateEnd
      }
      this.$store.dispatch('Sport/Game/set', data)
      this.$store.dispatch('Sport/Competitor/set', data)
      this.$store.dispatch('Sport/CompetitorPerson/set', data)
      this.$store.dispatch('Sport/CompetitorScore/set', data)
      this.$store.dispatch('Sport/Score/set', data)
    }
  }
}
</script>

<style scoped>
  aside{
    position:sticky;
    top:50px;
    flex:0 0 10px;
    height:100%;
    display:flex;
    flex-direction:column;
    transition:flex-basis 0.5s ease-in-out;
    overflow:hidden;
    margin-top:10px
  }
  aside[data-open="true"]{
    flex-basis:300px;
    max-width:100%
  }
  aside > div{
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0px;
  }
</style>
